// extracted by mini-css-extract-plugin
export default {"delivery-address":"OhCoupons_delivery-address__joj3j"};